<template>
	<div>
		<div v-if="loading"
			 class="h-60 flex items-center justify-center card card-white text-center text-gray-500 dark:text-slate-500">
			Подождите
		</div>
		<div v-else>
			<div v-if="post" class="space-y-8">
				<post-item :post="post" :view="1"></post-item>

				<div v-if="post.replies && post.replies.length" class="card card-white mx-auto max-w-4xl rounded-none md:rounded-xl">
					<div class="max-w-2xl mx-auto">
						<h2 class="text-xl font-medium mb-4">
							Ответы на пост
						</h2>

						<div class="max-h-80 overflow-scroll pl-1 no-scroll min-w-0 relative">
							<div v-for="reply in post.replies"
								 class="flex items-start border-l-[2px] border-purple-500/20 min-w-0 py-1">
								<div class="w-2 h-2 mt-2 shrink-0 -ml-[5px] rounded-full bg-purple-500"></div>
								<a :href="reply.url" target="_blank"
								   class="pl-3 cursor-pointer min-w-0">
									<div class="flex items-center gap-2 min-w-0">
										<avatar :ava="reply.author.ava"
												:title="reply.author.name"
												class="w-4 h-4 shrink-0"
										></avatar>
										<div class="w-full max-w-full truncate">
											{{ reply.header ? reply.header : 'Запись без заголовка' }}
										</div>
									</div>
									<smartdate
										:date="reply.date"
										class="whitespace-nowrap text-sm text-gray-500"></smartdate>
								</a>
							</div>
						</div>
					</div>
				</div>

				<div v-if="user.check() && !post.disable_comments"
					 class="card card-white mx-auto max-w-4xl rounded-none md:rounded-xl"
					 id="comments">
					<div class="max-w-2xl mx-auto">
						<comments
							:show-form="post.is_published"
							:postid="postid"
							:userid="post.user_id"
							:sortby="sort"
							:subscribed="post.is_subscribed"
							@commentsCountUpdated="updateCommentsCount"
						></comments>
					</div>
				</div>
			</div>
			<div v-else class="alert alert-danger text-center">
				Запись не найдена
			</div>
		</div>

	</div>
</template>

<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";
import User from "../../js/modules/User";

export default {
	props: [
		'postid',
	],
	data() {
		let user = new User();
		return {
			user: user,
			post: null,
			loading: true,
			sort: user.settings()?.comments_sort ?? 'last',
		};
	},
	mounted() {
		Client.get('/api/v1.1/posts/' + this.postid)
			.then(response => {
				this.post = response.data.data;
				this.loading = false;

				Echo.private('post.' + this.postid)
					.listen('.PostRated', e => {
						this.post.rate = e.rating;
					})
			})
			.catch(error => {
				this.loading = false;
				notify({
					type: 'error',
					text: 'Не удалось загрузить запись',
				});
			});
	},
	methods: {
		updateCommentsCount(newValue) {
			this.post.comments_count = newValue;
		}
	}
}
</script>
